import { Link } from "react-router-dom";

function HomeIcon(props) {
  return (
    <svg {...props} width="18" height="22" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 9.09209C0.75 7.86791 1.31058 6.71112 2.27142 5.95256L7.77142 1.61046C9.22466 0.463164 11.2753 0.463166 12.7286 1.61046L18.2286 5.95256C19.1894 6.71112 19.75 7.86791 19.75 9.09209V15.6537C19.75 17.8628 17.9591 19.6537 15.75 19.6537H14.25C13.6977 19.6537 13.25 19.206 13.25 18.6537V15.6537C13.25 14.5491 12.3546 13.6537 11.25 13.6537H9.25C8.14543 13.6537 7.25 14.5491 7.25 15.6537V18.6537C7.25 19.206 6.80228 19.6537 6.25 19.6537H4.75C2.54086 19.6537 0.75 17.8628 0.75 15.6537L0.75 9.09209Z" stroke="#914985" strokeWidth="1.5" />
    </svg>

  );
}

function BellIcon(props) {
  return (
    <svg {...props} width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.57617 0.75L8.57618 0H8.57617V0.75ZM14.6631 6.83691H15.4131V6.83691L14.6631 6.83691ZM16.4023 13.6348H17.1523V13.6347L16.4023 13.6348ZM13.6689 16.833L13.772 17.5759L13.772 17.5759L13.6689 16.833ZM8.57617 17.2715V18.0215H8.57618L8.57617 17.2715ZM3.48242 16.833L3.37929 17.5759L3.37941 17.5759L3.48242 16.833ZM0.75 13.6348L0 13.6347V13.6348H0.75ZM2.48926 6.83691L1.73926 6.83691V6.83691H2.48926ZM1.21645 11.9364L0.572198 11.5524L1.21645 11.9364ZM8.57617 0.75L8.57616 1.5C11.5236 1.50004 13.9131 3.88945 13.9131 6.83692L14.6631 6.83691L15.4131 6.83691C15.4131 3.06101 12.3521 5.56707e-05 8.57618 0L8.57617 0.75ZM14.6631 6.83691H13.9131V8.9279H14.6631H15.4131V6.83691H14.6631ZM15.9358 11.9364L15.2916 12.3204C15.5206 12.7045 15.6523 13.1532 15.6523 13.6348L16.4023 13.6348L17.1523 13.6347C17.1523 12.8754 16.9436 12.1623 16.58 11.5523L15.9358 11.9364ZM16.4023 13.6348H15.6523C15.6523 14.8807 14.7657 15.9237 13.5659 16.0901L13.6689 16.833L13.772 17.5759C15.7476 17.302 17.1523 15.5946 17.1523 13.6348H16.4023ZM13.6689 16.833L13.5659 16.0901C11.9954 16.3079 10.0681 16.5215 8.57617 16.5215L8.57617 17.2715L8.57618 18.0215C10.1768 18.0215 12.1892 17.7954 13.772 17.5759L13.6689 16.833ZM8.57617 17.2715V16.5215C7.08417 16.5215 5.15599 16.3079 3.58543 16.0901L3.48242 16.833L3.37941 17.5759C4.96222 17.7954 6.97547 18.0215 8.57617 18.0215V17.2715ZM3.48242 16.833L3.58556 16.0901C2.38612 15.9236 1.5 14.8808 1.5 13.6348H0.75H0C-5.96046e-08 15.5942 1.40384 17.3016 3.37929 17.5759L3.48242 16.833ZM0.75 13.6348L1.5 13.6348C1.50005 13.1532 1.63177 12.7045 1.86069 12.3204L1.21645 11.9364L0.572198 11.5524C0.208684 12.1623 8.23736e-05 12.8754 0 13.6347L0.75 13.6348ZM2.48926 8.92779H3.23926V6.83691H2.48926H1.73926V8.92779H2.48926ZM2.48926 6.83691L3.23926 6.83692C3.23928 3.88941 5.62867 1.5 8.57617 1.5V0.75V0C4.80023 0 1.73928 3.06099 1.73926 6.83691L2.48926 6.83691ZM1.21645 11.9364L1.86069 12.3204C2.11525 11.8933 2.47113 11.3543 2.73521 10.8252C3.00916 10.2764 3.23926 9.64077 3.23926 8.92779H2.48926H1.73926C1.73926 9.31539 1.61468 9.71141 1.3931 10.1554C1.16164 10.6191 0.881114 11.0341 0.572198 11.5524L1.21645 11.9364ZM14.6631 8.9279H13.9131C13.9131 9.64084 14.1431 10.2764 14.4171 10.8253C14.6812 11.3544 15.037 11.8933 15.2916 12.3204L15.9358 11.9364L16.58 11.5523C16.2712 11.0341 15.9906 10.6191 15.7592 10.1554C15.5376 9.71148 15.4131 9.31548 15.4131 8.9279H14.6631Z" fill="#914985" />
      <path d="M10.75 19.584C10.2826 20.2869 9.48347 20.7502 8.57609 20.7502C7.66871 20.7502 6.86954 20.2869 6.40218 19.584" stroke="#914985" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function BottomNavigation() {
  return (
    <nav
      className="sticky bottom-3 z-20 mx-auto rounded-[20px] w-11/12 bg-white/95 px-5 py-2 backdrop-blur"
      dir="ltr"
      aria-label="منوی اصلی"
      style={{boxShadow: '0px 0px 11.5px rgba(0, 0, 0, 0.13)'}}
    >
      <div className="grid grid-cols-3 items-center justify-between">
        <div className="flex justify-start w-full">
          <Link
            to="/notifications"
            className="flex flex-col items-center justify-center"
            aria-label="اعلان‌ها"
          >
            <BellIcon className="h-6 w-6" />
            <p className="text-[9px] text-[#914985]">
              اطلاعیه
            </p>
          </Link>
        </div>

        <div className="flex items-center justify-center">
          <div className="max-w-[116px] overflow-hidden">
            <img className="h-full w-full object-cover" src="/images/logo.png" alt="logo" />
          </div>
        </div>


        <div className="flex justify-end w-full">
          <Link
            to="/"
            className="flex flex-col items-center justify-center"
            aria-label="صفحه اول"
          >
            <HomeIcon className="h-6 w-6" />
            <p className="text-[9px] text-[#914985]">
              خانه
            </p>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default BottomNavigation;
